<template>
  <div class="flight responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'flights', label: 'Bundles' },
        ]"
        :entity="entity"
      />
      <SearchTable :entity="entity"  :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "flights",
  data() {
    return {
      listPageHeader,
      entity: Entities.FLIGHT,
    };
  },
  mounted: function () {
    this.setPageTitle("Bundles");
  },
  components: {
    PageHeader,
    SearchTable,
  },
  computed: {
    ...mapGetters({
      sort: "flightModule/sort",
      pagination: "flightModule/pagination",
      initialFilter: "flightModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "flightModule/updateSort",
      updatePagination: "flightModule/updatePagination",
      updateInitialFilter: "flightModule/updateInitialFilter"
    }),
  }
};
</script>
